export default "__VITE_ASSET__1cbb83c1__"